<template>
    <div class="col-lg-9">
        <div class="d-flex align-items-center mb-2">
            <h4 class="text-7">Users</h4>
        </div>

        <div class="custom-nav-container mb-3">
            <ul class="custom-nav-tabs">
                <li class="custom-nav-item">
                    <router-link class="custom-nav-link" :class="{ active: $route.path === '/business/users' }" :to="`/business/users`">
                        All Users
                    </router-link>
                </li>
                <li class="custom-nav-item">
                    <router-link class="custom-nav-link" :class="{ active: $route.path.includes('/edit') }" :to="`/business/users/${$route.params.id}/edit`">
                        Edit User
                    </router-link>
                </li>
            </ul>

            <div class="custom-nav-underline">
                <div class="custom-nav-active-underline" :style="{ left: activeTabPosition, width: activeTabWidth }"></div>
            </div>
        </div>

        <keep-alive>
            <transition name="slide-in-left">
                <router-view :permissions="permissions"></router-view>
            </transition>
        </keep-alive>
    </div>
</template>

<script>
export default {
    name: "Index",
    data() {
        return {
            activeTabPosition: "0px",
            activeTabWidth: "0px"
        };
    },
    methods: {
        updateActiveTabPosition() {
            this.$nextTick(() => {
                const activeTab = document.querySelector(".custom-nav-tabs .custom-nav-link.active");
                if (activeTab) {
                    this.activeTabPosition = `${activeTab.offsetLeft}px`;
                    this.activeTabWidth = `${activeTab.offsetWidth}px`;
                }
            });
        }
    },
    mounted() {
        this.updateActiveTabPosition();
    },
    watch: {
        "$route.path": function () {
            this.updateActiveTabPosition();
        }
    }
};
</script>
